// URL de base pour l'API backend
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const convertProspectToStudent = async (prospectId) => {
    try {
        // Appeler l'API du serveur pour convertir le prospect en étudiant
        const response = await fetch(`${API_BASE_URL}/api/convertProspect`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            body: JSON.stringify({ prospectId })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Une erreur inattendue est survenue lors de la conversion.');
        }

        return data;
    } catch (error) {
        console.error('Erreur lors de la conversion du prospect:', error);
        if (error.message.includes('Failed to fetch')) {
            throw new Error('Erreur de connexion au serveur. Veuillez réessayer.');
        }
        throw error;
    }
};

export const createStudent = async (data) => {
    try {
        // Appeler l'API du serveur pour créer un étudiant
        const response = await fetch(`${API_BASE_URL}/api/createStudent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            body: JSON.stringify(data)
        });

        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(responseData.error || 'Une erreur inattendue est survenue lors de la création.');
        }

        return responseData;
    } catch (error) {
        console.error('Erreur lors de la création de l\'étudiant:', error);
        if (error.message.includes('Failed to fetch')) {
            throw new Error('Erreur de connexion au serveur. Veuillez réessayer.');
        }
        throw error;
    }
};

